"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscriptionModuleFormValidationSchema = exports.SUBSCRIPTION_MODULE = void 0;
var _zod = require("zod");
var _types = require("./types");
const SUBSCRIPTION_MODULE = exports.SUBSCRIPTION_MODULE = 'subscription-module';
const subscriptionModuleFormValidationSchema = exports.subscriptionModuleFormValidationSchema = _zod.z.object({
  frequency: _zod.z.number().int().min(1),
  mode: _zod.z.nativeEnum(_types.SubscriptionModuleMode)
});
